<template>
  <div>
    <b-card title="欢迎 🚀">
      <b-card-text>欢迎使用勤工助学.<div v-if="getUserRole()==='TAxn'">
        当前所在用工单位：{{ userData.unitName ? userData.unitName :'未知用工单位（未获取到相关用户单位）' }}
      </div> </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { getUserRole } from '@/auth/utils'

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      getUserRole,
    }
  },
}
</script>

<style>

</style>
